import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import './Form.css';

const Form = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [over18, setOver18] = useState(false);
  const [optIn, setOptIn] = useState(false);
  const [cookie, setCookie] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const FormEndPoint = process.env.REACT_APP_GETFORM_ENDPOINT;
  const isValidUSPhone = value => {
    const digits = value.replace(/\D/g, '');
    if (digits.startsWith('1')) return digits.length === 11; // 1 + 10
    return digits.length === 10;
  };
  // Field-level validation
  const validateForm = () => {
    //prevent validation if cookie input is set
    if (cookie.trim() !== '') {
      return false;
    }
    const next = {};
    if (!over18) next.over18 = 'Required to enter';
    if (firstName.trim() === '') next.firstName = 'First name is required';
    if (lastName.trim() === '') next.lastName = 'Last name is required';
    if (phone.trim() === '') {
      next.phone = 'Please enter a phone number';
    } else if (!isValidUSPhone(phone)) {
      next.phone = 'Please enter a valid phone number';
    }
    if (email.trim() === '') {
      next.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      next.email = 'Invalid email address';
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    if (!validateForm()) {
      setSubmitting(false);
      return;
    }
    // Send multipart/form-data to Getform
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('over18', over18);
    formData.append('optIn', optIn);
    try {
      const response = await axios.post(FormEndPoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.status === 200) {
        navigate('/submittion');
      } else {
        setSubmitting(false);
      }
    } catch (err) {
      setSubmitting(false);
    }
  };
  return (
    <form
      id='nice-job-form'
      className='form nice-job-form'
      onSubmit={handleSubmit}
      noValidate
    >
      <span className='title-page-nice-job'>enter giveaway</span>
      <span className='subtitle-page-nice-job'>
        Enter for a chance to win some Holiday scratch-offs.
      </span>
      <input
        name='cookie'
        type='text'
        tabIndex="-1"
        autoComplete="off"
        onChange={
          e => setCookie(e.target.value)
        }
      >
      </input>
      <label htmlFor='firstName' className='label-container'>
        <input
          id='firstName'
          name='firstName'
          type='text'
          className={errors.firstName ? 'input-error' : ''}
          value={firstName}
          placeholder='First Name *'
          onChange={e => setFirstName(e.target.value)}
          aria-invalid={Boolean(errors.firstName)}
          aria-describedby={errors.firstName ? 'firstName-error' : undefined}
        />
        {errors.firstName && (
          <div id='firstName-error' className='error'>
            {errors.firstName}
          </div>
        )}
      </label>
      <label htmlFor='lastName' className='label-container'>
        <input
          id='lastName'
          name='lastName'
          type='text'
          className={errors.lastName ? 'input-error' : ''}
          value={lastName}
          placeholder='Last Name *'
          onChange={e => setLastName(e.target.value)}
          aria-invalid={Boolean(errors.lastName)}
          aria-describedby={errors.lastName ? 'error' : undefined}
        />
        {errors.lastName && (
          <div id='error' className='error'>
            {errors.lastName}
          </div>
        )}
      </label>
      <label htmlFor='email' className='label-container'>
        <input
          id='email'
          name='email'
          type='email'
          className={errors.email ? 'input-error' : ''}
          value={email}
          placeholder='Email *'
          onChange={e => setEmail(e.target.value)}
          aria-invalid={Boolean(errors.email)}
          aria-describedby={errors.email ? 'error' : undefined}
        />
        {errors.email && (
          <div id='email-error' className='error'>
            {errors.email}
          </div>
        )}
      </label>
      <label htmlFor='phone' className='label-container'>
        <input
          id='phone'
          name='phone'
          type='tel'
          pattern='^(\\+?1)? ?\\(?\\d{3}\\)?[-. ]?\\d{3}[-. ]?\\d{4}$'
          className={errors.phone ? 'input-error' : ''}
          value={phone}
          placeholder='Phone Number *'
          onChange={e => {
            let digits = e.target.value.replace(/\D/g, '');
            let hasCountryCode = false;
            if (digits.startsWith('1')) {
              hasCountryCode = true;
              if (digits.length > 11) digits = digits.slice(0, 11);
            } else {
              digits = digits.slice(0, 10);
            }
            let formatted = '';
            let localDigits = digits;
            if (hasCountryCode) {
              formatted = '+1 ';
              localDigits = digits.slice(1);
            }
            if (localDigits.length > 6) {
              formatted += `(${localDigits.slice(
                0,
                3
              )}) ${localDigits.slice(3, 6)}-${localDigits.slice(6)}`;
            } else if (localDigits.length > 3) {
              formatted += `(${localDigits.slice(
                0,
                3
              )}) ${localDigits.slice(3)}`;
            } else if (localDigits.length > 0) {
              formatted += `(${localDigits}`;
            }
            setPhone(formatted);
          }}
          aria-invalid={Boolean(errors.phone)}
          aria-describedby={errors.phone ? 'error' : undefined}
        />
        {errors.phone && (
          <div id='phone-error' className='error'>
            {errors.phone}
          </div>
        )}
      </label>
      <label htmlFor='ageRequirement' className='checkbox checkbox-container'>
        <input
          className='checkbox-input'
          id='ageRequirement'
          name='over18'
          type='checkbox'
          checked={over18}
          onChange={() => setOver18(!over18)}
          aria-invalid={Boolean(errors.over18)}
          aria-describedby={errors.over18 ? 'over18-error' : undefined}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            *I&apos;m over 18, live in North Carolina and have not already
            entered to win. Multiple entries will not increase odds of winning.
          </span>
          {errors.over18 && (
            <div id='over18-error' className='error'>
              {errors.over18}
            </div>
          )}
        </div>
      </label>
      <label htmlFor='optIn' className='checkbox checkbox-container'>
        <input
          className='checkbox-input'
          id='optIn'
          name='optIn'
          type='checkbox'
          checked={optIn}
          onChange={() => setOptIn(!optIn)}
        />
        <span>
          I&apos;d like to receive communication about promotions and free
          games.
        </span>
        {errors.optIn && (
          <div className='error' style={{ textAlign: 'center' }}>
            {errors.optIn}
          </div>
        )}
      </label>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <button className='generic-button' type='submit' disabled={submitting}>
          <span>{submitting ? 'SUBMITTING...' : 'SUBMIT'}</span>
        </button>
        <button
          className='generic-button'
          type='button'
          style={{
            width: '90%'
          }}
          onClick={() => {
            navigate('/');
          }}
        >
          <span
            style={{
              fontSize: '18px'
            }}
          >
            PLAY AGAIN
          </span>
        </button>
      </div>
    </form>
  );
};

export default Form;
